// extracted by mini-css-extract-plugin
module.exports = {"list":"EventsSpeakersList-module__list___1FHq-","item":"EventsSpeakersList-module__item___6diFq"};